<template>
  <parallax-container>
    <div class="sounds">
      <Header colorIcons="#9d99a1" />
      <div class="sounds__text-container">
        <div class="sounds__return" @click="goBack">
          <span class="arrow" />
          Powrót
        </div>
        <div class="sounds__list">
          <div
            class="sounds__player"
            v-for="(player, index) in store.sounds"
            :key="index"
          >
            <div
              class="sounds__speakerContainer"
              ref="control"
            >
              <speaker
                @click="()=>playSound(index)"
              />
              <audio
                ref="player"
                @timeupdate="()=>progressBar(index)"
                v-bind:src="player.src"
              ></audio>
            </div>
            <div class="sounds__content">
              <div class="sounds__content-title">{{player.title}}</div>
              <div class="sounds__content-lead">{{player.lead}}</div>
              <div
                class="sounds__timeline"
                @click="(event)=>changeActtualTime(event,index)"
                ref="tmln"
              >
                <div
                  class="sounds__timeline-active"
                  v-bind:style="{width: player.progressBar}"
                  @click="(event)=>changeActtualTime(event,index)"
                ></div>
              </div>
              <div class="sounds__time">
                <div class="sounds__actual-time">{{player.actualTime}}</div>
                <div class="sounds__whole-time">{{player.wholeSong}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="sounds__scroll" @mouseenter="scrollDown" @mouseleave="scrollBlock">
          <div class="sounds__scroll-arrow">></div>
          <div class="sounds__scroll-text">przewijaj treść</div>
        </div>
      </div>
      <div class="sounds__photo-container">
        <parallax-element
          :parallaxStrength="10"
          :type="'translation'"
          class="sounds__photo"
          :style="{ 'background-image': 'url(' + store.sounds_image + ')' }"
        >
        </parallax-element>
        <div class="sounds__photo-container-desc">
          {{store.sounds_image_author}}
        </div>
      </div>
    </div>
  </parallax-container>
</template>

<script>
import store from "../../store/index.js";
import Header from "../Header/Header";
import Speaker from "./partials/speaker.svg";
import VueMouseParallax from "vue-mouse-parallax";

export default {
  name: "sounds",
  components: {
    store,
    Header,
    Speaker
  },
  data() {
    return {
    };
  },
  computed: {
    store() {
      return store.state[String(this.$route.params.name)];
    }
  },
  methods: {
    stopAllPlayers() {
      this.$refs.player.forEach(function(el) {
        if (!el.paused) {
          el.pause();
        }
      });
      this.$refs.control.forEach(function(data) {
        data.style.backgroundColor="#f5edea";
      });
    },
    time(time) {
      let minutes = Math.floor(time / 60);
      let seconds = Math.floor(time % 60);
      if (seconds < 10) {
        return minutes + ":0" + seconds;
      } else {
        return minutes + ":" + seconds;
      }
    },
    changeActtualTime(event, index) {
      if (this.$refs.player[index].paused) {
        this.stopAllPlayers();
        this.$refs.player[index].play();
        this.$refs.control[index].style.backgroundColor="#f05a42";
      }
      let wholeSong = this.$refs.player[index].duration;
      let coords = this.$refs.tmln[index].getBoundingClientRect();
      let clickCoords = event.clientX - coords.left;
      let songActualTime = (clickCoords / coords.width) * wholeSong;
      this.$refs.player[index].currentTime = songActualTime;
    },
    progressBar(index) {
      let wholeSong = this.$refs.player[index].duration;
      let whSong = this.time(wholeSong);
      this.store.sounds[index].wholeSong = whSong;
      let actualTime = this.$refs.player[index].currentTime;
      let actTime = this.time(actualTime);
      this.store.sounds[index].actualTime = actTime;
      let progress = "" + (actualTime * 100) / wholeSong + "%";
      this.store.sounds[index].progressBar = progress;
    },
    playSound(index) {
      if (this.$refs.player[index].paused) {
        this.stopAllPlayers();
        this.$refs.control[index].style.backgroundColor="#f05a42";
        this.$refs.player[index].play();
      } else {
        this.$refs.control[index].style.backgroundColor="#f5edea";
        this.$refs.player[index].pause();
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    scrollDown() {
      this.intervalID = setInterval(() => {
        const list = document.querySelector(".sounds__list");
        list.scroll(0, list.scrollTop + 2);
      }, 10);
    },
    scrollBlock() {
      clearInterval(this.intervalID);
    }
  }
};
</script>

<style lang="scss" scoped>
.sounds {
  background-color: #3e3c40;
  display: flex;
  justify-content: space-between;
  &__text-container {
    background-color: #fff;
    width: 38%;
    margin-left: 8%;
    min-height: 100vh;
    padding-top: 5%;
    z-index: 4;
    position: relative;
  }
  &__photo-container-desc {
    position: absolute;
    bottom: 23%;
    left: 2%;
    color: rgba(255,255,255,0.6);
  }
  &__return {
    font-weight: bold;
    font-size: 2rem;
    font-family: "Oswald", sans-serif;
    text-transform: uppercase;
    color: #3e3c40;
    padding-left: 2rem;
    display: flex;
    align-items: center;
    cursor: pointer;

    .arrow {
      display: inline-block;
      height: 1rem;
      width: 5.5rem;
      background: url("./partials/arrow.png");
      background-size: cover;
      background-position: center;
      margin-right: 0.5rem;
    }
  }
  &__list {
    margin-top: 4vh;
    height: 75vh;
    overflow-y: scroll;
  }
  &__content {
    width: 85%;
    margin-left: 15%;
    @media (max-width: 991px) {
      margin-left: 20%;
    }
  }
  &__player {
    display: flex;
    margin: 3rem 0;
    padding-right: 3rem;
    position: relative;
  }
  &__speakerContainer {
    position: absolute;
    width: 9%;
    height: 36%;
    min-width: 30px;
    min-height: 30px;
    margin: 0 1.5%;
    background-color: #f5edea;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      width: 55%;
    }
  }
  &__speakerContainerSafari {
    position: relative;
    width: 50px;
    height: 50px;
    margin: 0 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width:50px;
    height:50px;
    svg {
      width: 25px;
    }
  }
  &__content-title {
    font-family: "Poppins", sans-serif;
    line-height: 1.4rem;
    font-size: 1rem;
    font-weight: 700;
    margin-bottom: 1rem;
    color: #3e3c40;
  }
  &__content-lead {
    font-family: "Poppins", sans-serif;
    line-height: 1.2rem;
    font-size: 0.8rem;
    color: #3e3c40;
  }
  &__timeline {
    width: 100%;
    height: 7px;
    background-color: #f5edea;
    margin: 1rem 0;
  }
  &__time {
    display: flex;
    justify-content: space-between;
    font-family: "Poppins", sans-serif;
    font-size: 0.8rem;
  }
  &__timeline-active {
    height: 7px;
    background-color: #f05a42;
  }
  &__photo-container {
    width: 54%;
    display: flex;
    position: relative;
    animation-name: showPhoto;
    animation-duration: 4s;
    justify-content: center;
    align-items: center;
    padding-bottom: 5%;

    @media (max-width: 1024px) {
      animation: none;
    }
  }

  &__photo {
    height: 80%;
    width: 100%;
    background-position: center;
    background-size: cover;
  }

  &__scroll {
    display: flex;
    padding: 1.5rem 1rem 1rem 2rem;
    align-items: center;
    cursor: pointer;
    max-width: 10rem;
  }
  &__scroll-arrow {
    font-family: "Poppins", sans-serif;
    font-size: 24px;
    width: 21px;
    height: 21px;
    transform: rotate(90deg);
    border: 1px solid black;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.5rem;
  }
  &__scroll-text {
    font-family: "Poppins", sans-serif;
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    color: #717073;
  }
}
scrollbar-width {
  width: 6px;
}
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background: #a9c9b8;
}
@keyframes showPhoto {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opaciy: 1;
    transform: translateX(0);
  }
}
</style>
